import React from 'react';
import IframeComm from 'react-iframe-comm';
import { compose, lifecycle } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { commonStyles } from '../../styles/styles';
import { connect } from 'react-redux';
import { xapiRequest } from '../../redux/reducers/xapi';

const LearnerThinkToolView = ({ classes, pathForIFrame, onReceiveMessage }) => {
  const attributes = {
    src: pathForIFrame,
    width: '100%',
    height: '100%',
  };
  return (
    <div style={{position:'absolute', top:0, left:0, right:0, bottom:30, zIndex:10000}}>
      
      <div className={classes.thinkTool}>
        {pathForIFrame && (
          <IframeComm attributes={attributes} handleReceiveMessage={onReceiveMessage} />
        )}
      </div>
    </div>
  );
};

LearnerThinkToolView.propTypes = {
  classes: PropTypes.instanceOf(Object),
  pathForIFrame: PropTypes.string,
  onReceiveMessage: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
});


const mapDispatchToProps = dispatch => ({
  
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),

});

export default compose(connect(
  null,
  mapDispatchToProps,
),lifecycle({
  componentWillMount(){
  
      // xapiRequest({ xapiType: `Opened`});

  },
  componentWillUnmount(){

  }
}),withStyles(styles),)(LearnerThinkToolView);
